import useInView from '../../hooks/useInView';
import CountUp from '../CountUp';

const Ring = ({ pct }) => (
  <svg className="proof-ring" viewBox="0 0 48 48" aria-hidden="true">
    <circle className="proof-ring-track" cx="24" cy="24" r="20" />
    <circle className="proof-ring-fill" cx="24" cy="24" r="20" pathLength="100" style={{ '--pct': pct }} />
  </svg>
);

// Two bars: ours vs a reference, widths as fractions of the longer one.
const Compare = ({ rows }) => (
  <div className="proof-compare" aria-hidden="true">
    {rows.map((row, i) => (
      <div key={row.label} className={`proof-compare-row${row.ours ? ' is-ours' : ''}`} style={{ '--w': `${row.size * 100}%`, '--i': i }}>
        <span className="proof-compare-bar" />
        <span className="proof-compare-label">{row.label}</span>
      </div>
    ))}
  </div>
);

const Dots = ({ count, cap = 40 }) => (
  <div className="proof-dots" aria-hidden="true">
    {Array.from({ length: Math.min(count, cap) }, (_, i) => (
      <span key={i} style={{ '--i': i }} />
    ))}
  </div>
);

const Visual = ({ visual }) => {
  if (!visual) return null;
  if (visual.type === 'ring') return <Ring pct={visual.pct} />;
  if (visual.type === 'compare') return <Compare rows={visual.rows} />;
  if (visual.type === 'dots') return <Dots count={visual.count} />;
  return null;
};

/**
 * Dark stats strip whose numbers count up on arrival, each with a small visual
 * that gives the number context. `children` render as the strip's action column.
 */
const ProofStats = ({ stats, children }) => {
  const [ref, inView] = useInView({ threshold: 0.4 });
  return (
    <section ref={ref} className={`stats-strip proof-stats${inView ? ' is-in' : ''}`}>
      {stats.map((stat) => (
        <div key={stat.label} className="proof-stat">
          <Visual visual={stat.visual} />
          <div>
            <CountUp className="metric-value" value={stat.value} start={inView} />
            <p className="metric-label">{stat.label}</p>
            {stat.note && <p className="proof-note">{stat.note}</p>}
          </div>
        </div>
      ))}
      {children}
    </section>
  );
};

export default ProofStats;
